import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={150}
      height={148}
      viewBox="0 0 150 148"
      fill="none"
    >
      <Path
        d="M131.25 3H18.75A15.792 15.792 0 007.608 7.593 15.625 15.625 0 003 18.667v87.111c0 .85.34 1.668.947 2.274A3.267 3.267 0 006.25 109h125c4.181 0 8.189-1.654 11.142-4.593A15.626 15.626 0 00147 93.333V18.667c0-4.151-1.656-8.135-4.608-11.074A15.795 15.795 0 00131.25 3z"
        fill="#014AB0"
        stroke="#fff"
        strokeWidth={6}
      />
      <Path
        d="M74.478 56.038a6.345 6.345 0 01-2.453-.498L27.996 36.86a6.252 6.252 0 01-3.198-3.41 6.168 6.168 0 01.085-4.654 6.258 6.258 0 013.32-3.295 6.349 6.349 0 014.7-.097l41.575 17.62 41.575-17.62a6.342 6.342 0 017.044 1.153 6.208 6.208 0 011.923 4.49 6.162 6.162 0 01-.506 2.437 6.216 6.216 0 01-1.43 2.047 6.284 6.284 0 01-2.125 1.33L76.931 55.538a6.345 6.345 0 01-2.453.499z"
        fill="#fff"
      />
      <Path
        d="M67.658 84.906v1.5h15.58v-7.727a7.695 7.695 0 00-2.288-5.469 7.823 7.823 0 00-5.503-2.257c-2.06 0-4.04.81-5.502 2.257a7.695 7.695 0 00-2.287 5.47v6.226zm20.369 10.952h-25.16a4.822 4.822 0 01-3.391-1.39 4.695 4.695 0 01-1.398-3.336V78.679c0-4.551 1.826-8.92 5.082-12.142A17.467 17.467 0 0175.447 61.5c4.612 0 9.032 1.814 12.288 5.037a17.084 17.084 0 015.082 12.142v12.453c0 1.249-.501 2.45-1.398 3.337a4.823 4.823 0 01-3.392 1.39z"
        fill="#014AB0"
        stroke="#fff"
        strokeWidth={3}
      />
      <Path
        d="M56.58 86.405h37.738c6.134 0 11.08 4.918 11.08 10.953v37.358c0 6.035-4.946 10.953-11.08 10.953H56.58c-6.134 0-11.08-4.918-11.08-10.953V97.358c0-6.035 4.946-10.953 11.08-10.953z"
        fill="#014AB0"
        stroke="#fff"
        strokeWidth={3}
      />
      <Path
        d="M75.449 126.99c-2.195 0-4.34-.645-6.162-1.85a10.983 10.983 0 01-4.077-4.917 10.835 10.835 0 01-.628-6.32 10.915 10.915 0 013.027-5.606 11.12 11.12 0 015.675-3.002 11.196 11.196 0 016.41.625 11.054 11.054 0 014.97 4.038 10.86 10.86 0 011.864 6.079c0 2.9-1.163 5.684-3.24 7.739a11.144 11.144 0 01-7.84 3.214z"
        fill="#01429C"
        stroke="#fff"
        strokeWidth={3}
      />
    </Svg>
  )
}

export default SvgComponent
